import { GridOff } from '@mui/icons-material';
import { Box, Card, Stack, Typography } from '@mui/material';
import * as React from 'react';

export interface INoDataPlaceholderProps {
    heading: string;
    text?: string;
}

export default function NoDataPlaceholder(props: INoDataPlaceholderProps) {
    return (
        <Box>
            <Stack alignItems={'center'} justifyContent={'center'} spacing={4} p={3}>
                <GridOff color='secondary' sx={{ fontSize: '120px' }} />
                <Typography color='secondary' variant='h4'>{props.heading}</Typography>
                <Typography color='secondary' variant='body1'>{props.text}</Typography>

            </Stack>
        </Box>
    );
}
